import React, { useState } from 'react';
import { Link } from 'gatsby';
import { BoldDropdown } from '@bold/web-components-react';
import { filterTradingPoints, filterZones, defaultMarker } from 'utils/mapFunctions';
import { segmentTrack } from 'vendors/segment';
import { loopParamsSegment } from 'utils/search-params-functions';
import cookieStorage from 'utils/storage';

import Chevron from 'assets/icons/ic_chevron.inline.svg';

import StoreMap from './StoreMap';

import './footer-map.scss';

const FooterMap = ({ tradingPoints, cities, promoHome }) => {
  const firstCity = cities.find(obj => obj.value === 'bogota');
  const [tradingPointsState, setTradingPointsState] = useState(tradingPoints);
  const [selectedZone, setSelectedZone] = useState(null);
  const [selectedCity, setSelectedCity] = useState('');
  const [locationDropdownState, setLocationDropdown] = useState(firstCity.zones);

  const [mapObject, setmapObject] = useState([]);

  const handleMapObject = obj => {
    setmapObject(obj);
  };

  const handleCityChange = e => {
    const newCity = e.detail.value;
    setSelectedCity(newCity);
    filterZones(newCity, cities, setLocationDropdown);
    if (newCity === 'todas') {
      setSelectedCity(null);
      setTradingPointsState(tradingPoints);
      setLocationDropdown(null);
      return;
    }
    filterTradingPoints(selectedZone, newCity, tradingPoints, setTradingPointsState);

    const { lat, lon } = defaultMarker(newCity, cities)?.defaultTradingPoint || { lat: 0, lon: 0 };

    if (mapObject.length > 0) {
      mapObject[0].setCenter({ lat, lng: lon });
    }
  };

  const handleZoneChange = e => {
    const newZone = e.detail.value;
    setSelectedZone(newZone);
    if (newZone === 'todas') {
      setSelectedZone(null);
      filterTradingPoints(null, selectedCity, tradingPoints, setTradingPointsState);
      return;
    }
    filterTradingPoints(newZone, selectedCity, tradingPoints, setTradingPointsState);
    setSelectedZone(null);
  };

  const justOneTimeSegment = () => {
    if (cookieStorage.getCookie('home-map-touch')) {
      return;
    }
    segmentTrack('Button Clicked', {
      type: 'bold.co',
      utm: loopParamsSegment(),
      page_name: promoHome ? 'promo_home' : 'cintilla_home',
      section_name: 'physical_stores',
    });
    cookieStorage.setCookieSession('home-map-touch', 1);
  };

  return (
    <div className="home-footer-map">
      <div className="section-container">
        <h3>
          <strong>Puntos físicos</strong>
        </h3>
        <div className="home-footer-map-filters">
          <div className="section-grid">
            <div className="bold-address">
              <p>
                <strong>Bold Store, centro de experiencia</strong>
              </p>
              <p>Carrera 11 # 93a - 20</p>
            </div>
            <BoldDropdown
              id="cityDropdown"
              className="filter-trigger"
              placeholder="Filtra por ciudad"
              showfield="city"
              valuefield="value"
              options={cities}
              error="false"
              disabled="false"
              name="city"
              userInput="bogota"
              onOptionSelected={handleCityChange}
              onClick={justOneTimeSegment}
            ></BoldDropdown>
            {locationDropdownState && (
              <BoldDropdown
                id="locationDropdown"
                className="filter-trigger"
                placeholder="Filtra por zona"
                showfield="name"
                valuefield="value"
                options={locationDropdownState}
                error="false"
                disabled="false"
                name="zone"
                onOptionSelected={handleZoneChange}
                onClick={justOneTimeSegment}
              ></BoldDropdown>
            )}
          </div>
        </div>
        <StoreMap tradingPoints={tradingPointsState} {...{ handleMapObject }} />
        <Link to="/contacto">
          <strong>Contáctanos</strong>
          <span>
            <Chevron />
          </span>
        </Link>
      </div>
    </div>
  );
};

export default FooterMap;
